import { Injectable } from "@angular/core";

/**
 * Serviço responsável por formatar Bytes e Packets
 */
@Injectable({
    providedIn: "root"
})
export class BytesPacketsFormatterService {
    format(value: number, units: string[]): string {
        if (isNaN(parseFloat(String(value))) || !isFinite(value) || parseFloat(String(value)) === 0) {
            return value != null ? String(value) : "";
        } else {
            const precision = value < 1000 ? 0 : 2;
            const unitIndex = Math.floor(Math.log(parseFloat(String(value))) / Math.log(1000));
            const converted = (parseFloat(String(value)) / Math.pow(1000, Math.floor(unitIndex))).toFixed(precision);
            return `${converted} ${units[unitIndex]}`;
        }
    }
}
